import { OrderingInitialState, SetFormError } from '@reducers/ordering/types';

export const setFormError = (state: OrderingInitialState, action: SetFormError): OrderingInitialState => ({
  ...state,
  hasError: action.payload,
});
